import React from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import Table from 'components/Table/Table';
import moment from 'moment';

function ClosingLogsModal(props) {
  const { model, setOpen, logs } = props;

  return (
    <ModalBase model={model} setOpen={setOpen} hideSave maxWidth="md" title="Logs">
      <Table
        tableHead={['#', 'Descripción', 'Hora', 'Usuario']}
        tableData={logs.map((log, index) => {
          return [
            index + 1,
            log.description,
            moment(log.created_at).format('DD-MM-YYYY LT'),
            log.user?.name || '-',
          ];
        })}
      />
    </ModalBase>
  );
}

export default ClosingLogsModal;
